import React, { useState, useMemo } from 'react';
import { BlockUi, Box, CardContent, Grid, Paper, Typography } from '@availity/element';

import { AvailityHeaderLogo, Footer } from '@/components';
import { useAppContext } from '@/context';
import { useFRStep } from '@/hooks';
import { ErrorPage } from '@/pages';

const InboundSSO = () => {
  const [currentStep] = useState();
  const { queryParams = {} } = useAppContext();

  const { authIndexValue = 'avSAMLInbound', ForceAuth = false } = queryParams;

  const { stepToRender = {}, errorCode } = useFRStep(currentStep, authIndexValue, ForceAuth);
  const { type } = stepToRender;

  const pageNodeToRender = useMemo(() => {
    let component;

    if (errorCode || type?.toLowerCase() === 'loginfailure') {
      component = <ErrorPage code={errorCode} />;
    }

    return (
      component || (
        <Grid
          id="inbound-sso-journey-grid-container"
          container
          role="main"
          display="flex"
          flexDirection="row"
          flexWrap="wrap"
          spacing={0}
          sx={{ minHeight: '100vh', justifyContent: 'center' }}
        >
          <Grid
            id="logout-page-content-grid"
            container
            display="flex"
            flexDirection="column"
            alignItems="center"
            flexGrow={1}
          >
            <AvailityHeaderLogo />
            <Grid direction="column" alignItems="center" justifyContent="center">
              <Paper variant="elevation" elevation={6} sx={{ width: { xs: '350px', sm: '500px' } }}>
                <CardContent>
                  <BlockUi
                    tag="div"
                    message={
                      <Typography variant="subtitle1">
                        <Box sx={{ fontWeight: 'bold' }}>Loading...</Box>
                      </Typography>
                    }
                    blocking
                  >
                    <Box sx={{ minHeight: '130px' }} />
                  </BlockUi>
                </CardContent>
              </Paper>
            </Grid>
          </Grid>
          <Footer />
        </Grid>
      )
    );
  }, [stepToRender]);

  return pageNodeToRender;
};

export default InboundSSO;
